import gql from 'graphql-tag';

export const SNOOZE_INVITATION_48H = gql`
mutation snoozeInvitation(
  $id: ID!
) {
   SnoozeInvitation(id: $id) {
    id
    status
    isArchived
    reminderDate {formatted}
    lastModifiedDate {formatted}
  }
}`

export const GET_INVITATION = gql`
query getInvitation(
  $id: ID!
) {
   Invitation(
    id: $id
  ) {
    id
    status
    isArchived
    reminderDate {formatted}
    lastModifiedDate {formatted}
    message
    components {
      id
      __typename
      title
      subtitle
      version
      file {
        uri
        size
        bitDepth
        samplingRate
        mimeType
      }
      project {
        id
        title
      }
      contributions {
        id
        contributor {
          id
          fullName
          accountId
            imageDepictions {
              thumbnail {
                  id,
                  file {
                      uri
                  }
              }
            }
        }
      }
      isContributionOf {
          id,
          role,
          isArchived
          contributor {
              id,
              accountId
              __typename
          }
      }
    }
    creator {
      id
      fullName
      alias
      description
      accountId
      imageDepictions {
        thumbnail {
            id,
            file {
                uri
            }
        }
      }
    }
    invitationTo {
      id
      __typename
    }
    invitee {
      id
      fullName
      accountId
      imageDepictions {
        file {
          uri
        }
      }
    }
  }
}
`

export const CREATE_PERSON_WITH_INVITATION = gql`
mutation createInvitedPerson (
  $invitedPerson: PersonInput
  $creatorId: ID!
  $projectId: ID!
  $inviteStatus: String!
  $invitationMessage: String
){
CreateInvitedPerson(
  invitedPerson: $invitedPerson
  creatorId: $creatorId
  projectId: $projectId
  inviteStatus: $inviteStatus
  invitationMessage: $invitationMessage
  ) {
    id
    authStatus
    invitationsReceived {
      id,
      status,
      reminderDate {
        formatted
      }
      invitationTo {
          id
        }
    }
    projectsMembership {
      id
    }
    }
  }
`

export const CREATE_INVITATION_WITH_SHARED_COMPONENT = gql`
  mutation createInvitationWithSharedComponent(
    $invitedPerson: PersonInput
    $creatorId: ID!
    $projectId: ID!
    $inviteStatus: String!
    $invitationId: String!
    $invitationMessage: String
    $componentId: ID!
  ) {
    CreateInvitationWithSharedComponent(
      invitedPerson: $invitedPerson
      creatorId: $creatorId
      projectId: $projectId
      inviteStatus: $inviteStatus
      invitationId: $invitationId
      invitationMessage: $invitationMessage
      componentId: $componentId
    ) {
      id
      invitee {
        id
        fullName
        authStatus
      }
    }
  }
`;
